var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1429 15.7142V1.96423C14.1429 1.27393 13.5672 0.714233 12.8571 0.714233H5.14286C4.80197 0.714233 4.47489 0.84607 4.23382 1.08044L0.376674 4.83044C0.135603 5.06482 0 5.38281 0 5.71423V15.7142C0 16.4052 0.575684 16.9642 1.28571 16.9642H12.8571C13.5672 16.9642 14.1429 16.4052 14.1429 15.7142ZM5.14286 4.46423C5.14286 5.15454 4.56725 5.71423 3.85714 5.71423H1.28571L5.14286 1.96423V4.46423Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7143 4.46423H15.4286V15.7142C15.4286 17.093 14.2754 18.2142 12.8572 18.2142H3.85718V19.4642C3.85718 20.1552 4.43286 20.7142 5.14289 20.7142H16.7143C17.4244 20.7142 18 20.1552 18 19.4642V5.71423C18 5.02393 17.4244 4.46423 16.7143 4.46423Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.6afee1f23c4c8cca9b9ca153d12dc16e.svg";
export { ForwardRef as ReactComponent };